import {DefaultPageProps} from "@models/DefaultProps.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {useEffect, useState} from "react";
import {ISolicitacaoOrcamento} from "@models/solicitacoes/orcamento.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {_OrcamentosEndpoints} from "@localization/siteMap/endpoints/_OrcamentosEndpoints.ts";
import {IFlag} from "@models/shared/IFlag.ts";
import IconStepper from "@shared/custom/IconStepper.tsx";
import dayjs from "dayjs";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {CheckOutlined, ClearOutlined, QuestionMark} from "@mui/icons-material";
import {ConfirmationComponent} from "@components/shared/ConfirmationComponent.tsx";
import {Typography} from "@mui/material";
import {useApi} from "@contexts/hooks/api/useApi.ts";

interface OrcamentoFlagsPageProps extends DefaultPageProps {
    filtros?: {
        orcamentoId?: number
    },
    preset?: {
        orcamento?: ISolicitacaoOrcamento
    }
}

export function OrcamentoFlagsPage(props: OrcamentoFlagsPageProps) {
    const {Get} = useApi()
    const {createAlertFromResponse, addPopUp, closePopUp} = useAlert()
    const {filtros, preset} = props;
    const [_orcamento, setOrcamento] = useState(preset?.orcamento);
    const [flags, setFlags] = useState<IFlag[]>([])
    const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10});

    useEffect(() => {
        if (pagination.page <= 0) {
            setPagination({...pagination, page: 1})
            return;
        }
        setPagination(prev => ({...prev, loading: true}))
        Get(_OrcamentosEndpoints.GetFlagsOrcamento({idOrcamento: filtros?.orcamentoId ?? preset?.orcamento?.id}, pagination)).then(x => {
            if (x.hasData) {
                setFlags(x.items)
                setPagination(prev => ({...prev, ...x.pagination}))
            }
        }).finally(() => {
            setPagination(prev => ({...prev, loading: false, ignoreCache: false}))
        })


    }, [pagination.page, filtros?.orcamentoId, preset?.orcamento]);


    useEffect(() => {
        if (props.preset?.orcamento)
            setOrcamento(props.preset?.orcamento);
    }, [props.preset?.orcamento]);

    return (
        <DefaultContainer>
            <IconStepper orientation={'vertical'} size={'sm'} steps={flags.map(x => {
                const o = x.orcamentos?.[0]
                return {
                    variant: 'solid',
                    label: x.id + ' ' + x.nome,
                    usuarioId: o?.usuarioAtivacaoId,
                    icon: o?.usuarioAtivacaoId == null ? <QuestionMark/> : !o?.isAtivo ? <ClearOutlined/> :
                        <CheckOutlined/>,
                    color: o?.usuarioAtivacaoId == null ? 'neutral' : !o?.isAtivo ? 'danger' : 'success',
                    time: o?.dataAtivacao,
                    onClick: () => {
                        if (!filtros?.orcamentoId && !preset?.orcamento?.id) return;
                        addPopUp({
                            title: 'Ativar/desativar sinalização',
                            content: <ConfirmationComponent options={[
                                {
                                    label: o?.isAtivo ? 'Desativar' : 'Ativar',
                                    color: o?.isAtivo ? 'error' : 'success',
                                    endIcon: o?.isAtivo ? <ClearOutlined/> : <CheckOutlined/>,
                                    onClick: () => {
                                        Get(_OrcamentosEndpoints.SetFlagOrcamento({
                                            isAtivo: !(o?.isAtivo ?? false),
                                            dataAtivacao: dayjs(),
                                            orcamentoId: filtros?.orcamentoId ?? preset?.orcamento?.id ?? 0,
                                            usuarioAtivacaoId: 0,
                                            flagId: x.id
                                        })).then(x => {
                                            createAlertFromResponse(x)
                                            if (x.status == 'Success') {
                                                setPagination({...pagination, page: 0, ignoreCache: true})
                                                closePopUp()
                                            }
                                        })
                                    }
                                }
                            ]}>
                                <Typography>Deseja {o?.isAtivo ? 'desativar' : 'ativar'} a
                                    sinalização {x.nome} no
                                    orçamento {filtros?.orcamentoId ?? preset?.orcamento?.id ?? 0}?</Typography>
                            </ConfirmationComponent>
                        })
                    }
                }
            })}>
            </IconStepper>
        </DefaultContainer>
    )
}